import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedLoginRoute from "./components/ProtectLoginRoute";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import ReportDetail from "./components/ReportDetail";
import TransactionDetail from "./components/TransactionDetail";
import axios from "axios";

//// IPIFY API URL to get the user's public IP address
const IPIFY_API_URL = "https://api.ipify.org?format=json";

function App() {
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    const checkUserAccess = async () => {
      try {
        // 1. Get user's IP
        const ipRes = await axios.get(IPIFY_API_URL);
        const userIp = ipRes.data.ip;
  
        // 2. Get whitelist
        const whitelistRes = await axios.get("https://backend.bsebblockchain.in/whitelist-ip");
        const data = whitelistRes.data;
  
        let list = [];
        if (Array.isArray(data?.data)) list = data.data;
        else if (Array.isArray(data)) list = data;
  
        const allowedIps = list.map((item) => (item?.ip || item).trim());

        // 3. Compare
        setIsBlocked(!allowedIps.includes(userIp));
      } catch (error) {
        console.error("Error checking user access:", error?.message ?? error);
        setIsBlocked(true);
      }
    };

    checkUserAccess();
  }, []);
  
  
  // If the user's IP is blocked, show an error or redirect
  if (isBlocked) {
    return (
      <div>
        Access Restricted: Your IP address is not allowed to access this application. Please contact
        the administrator if you need access..
      </div>
    );
  }

  return (
    <Router>
      <ToastContainer position="top-right" />
      <Routes>
        <Route
          path="/login"
          element={
            <ProtectedLoginRoute>
              <Login />
            </ProtectedLoginRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report/:reportId"
          element={
            <ProtectedRoute>
              <ReportDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction"
          element={
            <ProtectedRoute>
              <TransactionDetail />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
